import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Configuration du QueryClient
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // Désactive la revalidation au focus de la fenêtre
      retry: 2, // Nombre de tentatives en cas d'échec
    },
  },
});

const ReactQueryProvider = ({ children }) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};

export default ReactQueryProvider;
